module.exports = __webpack_public_path__ + "assets/img/advantage-item6.ac749ec6.png";